// If anyone knows how to do this without relying on any here,
// I'm very very interested.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type EventMap = Record<string, any>;
type EventKey<T extends EventMap> = string & keyof T;
type EventCallback<T> = (params: T) => void;

interface Emitter<T extends EventMap> {
  on<K extends EventKey<T>>(eventName: K, fn: EventCallback<T[K]>): void;
  off<K extends EventKey<T>>(eventName: K, fn: EventCallback<T[K]>): void;
  emit<K extends EventKey<T>>(eventName: K, params: T[K]): void;
}

function Emitter<T extends EventMap>(): Emitter<T> {
  const listeners: {
    [K in keyof EventMap]?: Array<(p: EventMap[K]) => void>;
  } = {};

  return {
    on(key, fn) {
      listeners[key] = (listeners[key] ?? []).concat(fn);
    },
    off(key, fn) {
      listeners[key] = (listeners[key] ?? []).filter(
        (listener) => listener !== fn,
      );
    },
    emit(key, params) {
      (listeners[key] ?? []).forEach((f) => f(params));
    },
  };
}

export type { EventCallback };
export { Emitter };
